export default "__VITE_ASSET__7QRU3UOC__"